import React, { useEffect, useState } from 'react';
import { withRouter, useHistory } from 'react-router-dom';
import Wrapper from '../../components/Wrapper/Wrapper';
import { tripTableHeight, tableHeightWithSparkline } from "../../../styleVariables";
import { DataGrid } from '@material-ui/data-grid';
import { connect } from "react-redux";
import { logoutUser } from "../../../store/actions/authActionCreators";
import MUIDataTable from "mui-datatables";
import { getFastagVehiclesData, getWalletBalance, getSingleFastTagDetails } from "../../../store/actions/fastagActionCreators";
import * as logger from "../../../logger";
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import InputAdornment from '@material-ui/core/InputAdornment';
import SearchIcon from '@material-ui/icons/Search';
import { numberFormat, getDatePickerDateInStringDDMMMYYYY } from '../../../utils/utils'
import Button from '@material-ui/core/Button';
import AddIcon from '@material-ui/icons/Add';
import Grid from '@material-ui/core/Grid';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import useStyles from '../css/listing-fastag'
import ActionIconButton from '../../components/Actions/ActionIconButton';
import EditIcon from '@material-ui/icons/Edit';
import ColumnActions from '../../components/Actions/ColumnActions';
import VisibilityIcon from '@material-ui/icons/Visibility';
import { trackDwebEvent } from '../../analytics';
import { ShopKhataEmptyStateIcon } from '../../../components/icons';
import FiberManualRecordIcon from "@material-ui/icons/FiberManualRecord";
import DeleteIcon from '@material-ui/icons/Delete';
import FastTagTruckInfoDialog from "../../components/FastTagDialogAndSidebar/FastTagTruckInfoDialog";
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import ActionButton from '../../components/Actions/ActionButton';
import RechargeFastagSideBar from '../../components/RightSideBar/RechargeFastagSideBar';
import queryString from "query-string";
import SuccessDialog from '../../components/Verfication/SuccessDialog';
import FailureDialog from '../../components/Verfication/FailureDialog';
import RewardConsumptionDialog from '../../components/Verfication/RewardConsumptionDialog';
import { getPaymentStatus } from '../../../store/actions/OnlinePaymentActionCreators';
const Fastag = ({ user, fastag, dispatchGetWalletBalance, dispatchGetFastagDataAction, dispatchGetSingleFastTagDetails, dispatchGetPaymentStatus }) => {
    const classes = useStyles();
    let history = useHistory();
    let search = window.location.search;
    const params = queryString.parse(search);
    let orderId = params["order_id"];
    const [searchText, setSearchText] = useState("");
    const [fastagVehicles, setFastagVehicles] = useState([]);
    const [initialEmpty, setInitialEmpty] = useState(false);
    const [addShopOpen, setAddShopOpen] = useState(false);
    const [truckInfoDialog, setTruckInfoDialog] = useState(false);
    const [rechargeFastagOpen, setRechargeFastagOpen] = useState(false);
    const [defaultData, setDefaultData] = useState(null)
    const [successCreation, setSuccessCreation] = useState(false);
    const [failureCreation, setFailureCreation] = useState(false);
    const [rewardConsumption, setRewardConsumption] = useState(false);
    const [rewardAmount, setRewardAmount] = useState(0);

    useEffect(() => {
        trackDwebEvent('Dweb FASTag page', {});
    }, []);
    useEffect(() => dispatchGetFastagDataAction(searchText, (data) => {
        // if (data && data.status && data.status.code == 200 && data.response && data.response.length <= 0) {
        //     setInitialEmpty(true)
        // } else {
        //     setInitialEmpty(false)
        // }
        if (orderId) {
            dispatchGetPaymentStatus({
                orderId: orderId
            }, (response) => {
                if (response && response.status && response.status.code == 200) {
                    if (response.response.message == "Transaction Failed.") {
                        handleFailureOpen()
                        setTimeout(() => {
                            handleFailureClose(data)
                        }, 3000);
                    } else if (response.response && response.response.rewardAmountUsed && Number(response.response.rewardAmountUsed) != 0) {
                        setRewardAmount(response.response.rewardAmountUsed)
                        handleRewardsOpen()
                        setTimeout(() => {
                            handleRewardsClose(data)
                        }, 3000);
                    } else {
                        handleSuccessOpen()
                        setTimeout(() => {
                            handleSuccessClose(data)
                        }, 3000);
                    }
                } else {
                    handleFailureOpen()
                    setTimeout(() => {
                        handleFailureClose(data)
                    }, 3000);
                }
            }, () => {
                handleFailureOpen();
                setTimeout(() => {
                    handleFailureClose(data)
                }, 3000);
            })
        }
    }), [
        dispatchGetFastagDataAction
    ]);
    useEffect(() => {

        if (fastag.vehicles) {
            setFastagVehicles(fastag.vehicles);
            if (fastag.vehicles.length > 0) {
                setInitialEmpty(false);
            } else {
                setInitialEmpty(true);
            }
        }

    }, [fastag.vehicles]);

    const handleTransactionRow = (index) => {
        if (index == 0 || index) {

            const fastTagStatus = fastagVehicles && fastagVehicles[index] && fastagVehicles[index].status ? fastagVehicles[index].status : "";
            const fastTagId = fastagVehicles[index].id;
            const vehicleNumberPreffix = fastagVehicles[index].vehicleNumberPrefix;
            const vehicleNumberSuffix = fastagVehicles[index].vehicleNumberSuffix;
            const status = fastagVehicles[index].status;
            const fastTagBalance = fastagVehicles && fastagVehicles[index] && fastagVehicles[index].balanceAmount ? fastagVehicles[index].balanceAmount : "";

            if (fastTagStatus && fastTagStatus == "active") {
                history.push({
                    pathname: `/fastag/single-truck/${fastTagId}`,
                    state: {
                        id: fastTagId,
                        fastagBalance: fastTagBalance || null,
                        pageTitle: [vehicleNumberPreffix, vehicleNumberSuffix],
                        fastTagId: fastTagId
                    }
                });
            } else if (fastTagStatus == "inactive" || fastTagStatus == "blacklisted" || fastTagStatus == "unregistered") {

                dispatchGetSingleFastTagDetails(fastTagId,
                    (data) => {
                        if (data && data.status && data.status.code == 200) {
                            logger.log("Fastag listing Dweb", "Get Single Fast Tag Successfull");
                            setTruckInfoDialog(true);
                        }
                    },
                    () => {
                        logger.log("Fastag listing Dweb", "Get Single Fast Tag Failed");
                    }
                )
            }


        }
    }
    const handleAddShopClick = () => {
        setAddShopOpen(true);
    }
    const handleAddShopModalClose = (status) => {
        setAddShopOpen(status);
    }
    const handleShopSave = (status) => {
        dispatchGetFastagDataAction(searchText, (data) => {
            if (data && data.status && data.status.code == 200 && data.response && data.response.length <= 0) {
                setInitialEmpty(true)
            } else {
                setInitialEmpty(false)
            }
        })
    }
    const handleRechargeFastagOpen = (e, data) => {
        e.preventDefault()
        e.stopPropagation()
        if (data && data.id) {
            setDefaultData({
                id: data.id,
                vehicleId: data.id,
                amount: data && data.rechargeAmount ? data.rechargeAmount : null
            })
            dispatchGetSingleFastTagDetails(data.id,
                (data) => {
                    if (data && data.status && data.status.code == 200) {
                        dispatchGetWalletBalance(data, (res) => {
                            if (data && data.status && data.status.code == 200) {
                                setRechargeFastagOpen(true)
                            }
                        }, () => {

                        })
                    } else {
                        setDefaultData(null);
                    }
                },
                () => {
                    setDefaultData(null);
                }
            )
        }
    }
    const handleRechargeFastagClose = (entityData) => {
        setDefaultData(null);
        setRechargeFastagOpen(false);
    }
    const goToViewFastag = () => {
        history.push({
            pathname: `/fastag`,
            state: {
                id: 1,
                pageTitle: 'FASTag Recharge'
            }
        });
    }
    const handleSuccessOpen = () => {
        setSuccessCreation(true)
    }
    const handleSuccessClose = (data) => {
        setSuccessCreation(false)
        goToViewFastag(data && data.response ? data.response : null)
    }
    const handleFailureOpen = () => {
        setFailureCreation(true)
    }
    const handleFailureClose = (data) => {
        setFailureCreation(false)
        goToViewFastag(data && data.response ? data.response : null)
    }
    const handleRewardsOpen = () => {
        setRewardConsumption(true)
    }
    const handleRewardsClose = (data) => {
        setRewardConsumption(false)
        goToViewFastag(data && data.response ? data.response : null)
    }
    const muiColumns = [
        {
            name: "vehicleNumber",
            label: "Truck Number",
            options: {
                filter: true,
                sort: false,
                customBodyRenderLite: (dataIndex, rowIndex) => {
                    let data = fastagVehicles[dataIndex];
                    return (
                        <>
                            <div style={{ display: 'flex', textTransform: 'uppercase', alignItems: 'center' }}>
                                <div style={{ display: 'flex', width: '100%', maxWidth: 130 }} >
                                    {data && data.vehicleNumArrayDweb && data.vehicleNumArrayDweb.length > 2 && data.vehicleNumArrayDweb.map((item) => (
                                        <div className={classes.vehileNumber}>{item}</div>
                                    ))
                                    }
                                    {data && data.vehicleNumArrayDweb && data.vehicleNumArrayDweb.length <= 2 && data.vehicleNumArrayDweb.map((item) => (
                                        <div className={classes.vehileNumber}>{item}</div>
                                    ))
                                    }
                                </div>
                                <div className={classes[data.status]}><span className={classes.statusName} >{data.status}</span></div>
                            </div>
                        </>
                    )
                }
            },
        },
        {
            name: "bankName",
            label: "Bank",
            options: {
                filter: true,
                sort: false,
                customBodyRenderLite: (dataIndex, rowIndex) => {
                    let data = fastagVehicles[dataIndex];
                    return (<>
                        {data && data.bankName ? <div className={classes.divAlignCenter} style={{ justifyContent: 'space-between' }}>
                            <div className={classes.bankName} >{data.bankName}</div>
                            {data && data.bankIconUrl && <div>
                                <img className={classes.bankIcon} src={data.bankIconUrl} alt={data.bankName} />
                            </div>}
                        </div> : <span><strong>--</strong></span>}
                    </>)
                }
            },
        },
        {
            name: "balance",
            label: "FASTag Balance",
            options: {
                filter: true,
                sort: false,
                customBodyRenderLite: (dataIndex, rowIndex) => {
                    let data = fastagVehicles[dataIndex];
                    return (
                        <>
                            {data && data.balanceAmount ? <div className={classes.drflex}>
                                <div className={classes.amount} >{numberFormat(Number(data.balanceAmount))}</div>
                                {data && data.dateDisplay && <><FiberManualRecordIcon className={classes.dotOp} />
                                    <div className={classes.trDate} ><span className={classes.trLastDate}>Last Fetched on </span>{data.dateDisplay}</div></>}
                                {/* <ChevronRightIcon className={classes.arrowBalance}   /> */}
                            </div> : <span><strong>--</strong></span>}
                        </>
                    )
                }
            },
        },
        // {
        //     name: "dateDisplay",
        //     label: " ",
        //     options: {
        //         filter: true,
        //         sort: false,
        //         customBodyRenderLite: (dataIndex, rowIndex) => {
        //             let data = fastagVehicles[dataIndex];
        //             return (
        //                 data && data.status && data.status == 'active' ? <ColumnActions>
        //                     <ActionButton size="small" onClick={(e) => { handleRechargeFastagOpen(e, data) }} className={classes.actionButton}>
        //                         Recharge
        //                     </ActionButton>
        //                 </ColumnActions> : <span className={classes.actionDash}><strong>--</strong></span>
        //             )
        //         }
        //     },
        // }
    ];
    const muiData = fastagVehicles;
    const options = {
        rowsPerPage: 100,
        rowsPerPageOptions: [10, 100, 250],
        filterType: "multiselect",
        fixedHeader: true,
        tableBodyHeight: tripTableHeight,
        selectableRows: 'none',
        searchOpen: true,
        search: false,
        jumpToPage: false,
        download: false,
        filter: false,
        print: false,
        viewColumns: false,
        onRowClick: (rowData, rowMeta) => {
            handleTransactionRow(rowMeta.dataIndex);
        },
        customToolbar: (data) => {
            return <>
                {/* <Button variant="contained" classes={{ root: classes.addPartyCta, label: classes.label, }} color="primary" onClick={handleAddPartyClick}>
                  <AddIcon /> Add Vehicle
              </Button>
              <Button variant="contained" classes={{ root: classes.addTripCta, label: classes.label, }} color="primary" onClick={goToTrip}>
                  <AddIcon /> Add Trip
              </Button> */}
            </>
        },
        customToolbarSelect: (selectedRows, displayData, setSelectedRows) => {

        },
        searchProps: {
            variant: "outlined",
            // value: searchText,
            InputProps: {
                startAdornment: <InputAdornment position="start"><SearchIcon /></InputAdornment>,
            },
            onBlur: (e) => {
            },
            onKeyUp: (e) => {
            },
            onKeyDown: (event) => {
                if (event.keyCode === 27) {
                }
            }
        },
        searchPlaceholder: 'Search for a Truck',
        onSearchChange: (txt) => {
            setSearchText(txt ? !txt.replace(/\s/g, '').length ? txt.trim() : txt : "");
            /*if (txt && txt.trim().length > 1) {
                dispatchGetFastagDataAction(txt ? !txt.replace(/\s/g, '').length ? txt.trim() : txt : "")
            } else if (searchText && txt && txt.trim().length <= 1) {
                setSearchText("");
                dispatchGetFastagDataAction(null)
            }*/
        },
        onSearchClose: () => {
        },
        customSearch: (searchQuery, currentRow, columns) => {
            let isFound = false;
            if (searchQuery && searchQuery.trim().length > 0) {
                searchQuery = searchQuery.trim()
                currentRow.forEach(col => {
                    if (col && col.toString().toUpperCase().indexOf(searchQuery.toUpperCase()) >= 0) {
                        isFound = true;
                    }
                });
            } else {
                isFound = true;
            }
            return isFound;
        },
        textLabels: {
            body: {
                noMatch: "No Data found",
                toolTip: "Sort",
                columnHeaderTooltip: column => `Sort for ${column.label}`
            }
        }
    };

    const handleFastTagTruckInfoClose = () => {
        setTruckInfoDialog(false);
    }

    return (
        <>
            <Wrapper>
                <Paper className={classes.pageContentDIvTrip} elevation={3}>
                    {initialEmpty ? <div className={classes.listEmptyState}>

                        <img className={classes.listEmptyStateImgShop} src={`${process.env.PUBLIC_URL}/assets/images/fasttag-empty.svg`} alt={"FastTag Empty"} />

                        <Typography className={classes.listEmptyStateDesc} >
                            Add a Truck to Recharge FASTag and Check Balance
                        </Typography>
                    </div> : <div className={classes.fastagTable}>
                        <MUIDataTable title={""} className={classes.fastagVehiclesTable} data={muiData} columns={muiColumns} options={options} />
                    </div>}
                </Paper>
            </Wrapper>
            {successCreation && <SuccessDialog selectedValue={defaultData} open={successCreation} title={"Payment Successful"} onClose={handleSuccessClose} />}
            {failureCreation && <FailureDialog selectedValue={defaultData} open={failureCreation} title={"Payment Failed"} onClose={handleFailureClose} />}
            {rewardConsumption && <RewardConsumptionDialog selectedValue={defaultData} open={rewardConsumption} subTitle={numberFormat(Number(rewardAmount))} title={"You Saved"} onClose={handleRewardsClose} />}


            {truckInfoDialog && <FastTagTruckInfoDialog open={truckInfoDialog} onClose={handleFastTagTruckInfoClose} />}
            {rechargeFastagOpen && <RechargeFastagSideBar
                rightSideBarOpen={rechargeFastagOpen}
                defaultData={defaultData}
                sideBarTitle={'Recharge FASTag'}
                handleSubmit={event => { }}
                toggleRightSideBar={handleRechargeFastagClose}
            ></RechargeFastagSideBar>}
        </>
    );
};
const mapStateToProps = (state) => (state);
const mapDispatchToProps = (dispatch) => ({
    dispatchLogoutAction: () => dispatch(logoutUser()),
    dispatchGetFastagDataAction: (requestData, onSuccess, onFailure) =>
        dispatch(
            getFastagVehiclesData(
                requestData,
                (data) => {
                    //trackDwebEvent('Dweb Shop Khata Page', {});
                    if (onSuccess) {
                        onSuccess(data);
                    }
                },
                () => {
                }
            )
        ),
    dispatchGetSingleFastTagDetails: (fastTagId, onSuccess, onFailure) => {
        dispatch(getSingleFastTagDetails(fastTagId, onSuccess, onFailure))
    },
    dispatchGetPaymentStatus: (data, onSuccess, onError) => {
        dispatch(getPaymentStatus(data, onSuccess, onError))
    },
    dispatchGetWalletBalance: (data, onSuccess, onError) => {
        dispatch(getWalletBalance(data, onSuccess, onError))
    }
});
const FastagWithRouter = withRouter(Fastag);
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(FastagWithRouter);
